import { CaseItem as CaseItemApi, Cases as CasesApi } from '../../api/casesListing/types';
import { CaseItem, Cases } from '../../pages/CaseListingPage/CaseListingPage.types';
import { format } from 'utils/date';

const DATE_FORMAT = 'DD/MM/YYYY hh:mm a';

export const caseFromApi = (caseItem: CaseItemApi): CaseItem => {
  return {
    ...caseItem,
    updatedAt: caseItem.updatedAt ? format(caseItem.updatedAt).dateTime(DATE_FORMAT) : '',
  };
};

export const casesFromApi = (cases: CasesApi): Cases => {
  return {
    cases: cases.cases.map((caseItem) => caseFromApi(caseItem)),
  };
};
